import { FeatureAccess } from '../pages/AccountSettings/components/rolesAndPermissions/PermissionsList';
import { FeatureAccessItem, ISummaryData } from '../types';
import { validateFeatureFlag } from './featureFlagService';
import useStore from '../store';

export enum LimitedFeatureType {
  TransactionsListView = 'TransactionsListView',
  TransactionListCategorize = 'TransactionListCategorize',
  TransactionsAddReceiptAndNote = 'TransactionsAddReceiptAndNote',
  DashboardWidgetsAndAccountBalance = 'DashboardWidgetsAndAccountBalance',
  SavingsSubAccount = 'SavingsSubAccount',
  TaxBucket = 'TaxBucket',
  BalanceToggle = 'BalanceToggle',
  AddMoneyACHLinkedAccount = 'AddMoneyACHLinkedAccount',
  AddMoneyACHDirectDeposit = 'AddMoneyACHDirectDeposit',
  AddMoneyIncomingWireTransfer = 'AddMoneyIncomingWireTransfer',
  AddMoneyCheckDeposit = 'AddMoneyCheckDeposit',
  AddMoneyCashDeposit = 'AddMoneyCashDeposit',
  SendMoneyACHLinkedAccount = 'SendMoneyACHLinkedAccount',
  SendMoneyACH = 'SendMoneyACH',
  SendMoneyWireOut = 'SendMoneyWireOut',
  SendMoneyMailACheck = 'SendMoneyMailACheck',
  BillPay = 'BillPay',
  Invoices = 'Invoices',
  Reports = 'Reports',
  AppCenter = 'AppCenter',
  AccountantAI = 'AccountantAI',
  CardActions = 'CardActions',
  ContactDetails = 'ContactDetails',
  BusinessDetails = 'BusinessDetails',
  InAppLimits = 'InAppLimits',
  UpgradePlan = 'UpgradePlan',
  TeamMemberPermission = 'TeamMemberPermission',
  ProductTour = 'ProductTour',
  SendMoneyPayBill = 'SendMoneyPayBill',
}

export const featureAccess = (flagName: string | null, type?: LimitedFeatureType): FeatureAccess => {
  if (flagName && !validateFeatureFlag(flagName)) {
    // Feature flag is off
    return FeatureAccess.NONE;
  }
  const summaryData: ISummaryData = useStore.getState().summary;
  if (!summaryData.authorizedUserData || !type) {
    // Logged-in user is a regular user
    // TODO: Validate this is the correct way to check if a user is an authorized user
    return FeatureAccess.READ_WRITE;
  }

  // Authorized user
  const featureAccessItems = summaryData.authorizedUserData?.authorizedUserFeatureItems;
  const firstItem: FeatureAccessItem | undefined = featureAccessItems?.find((item) => item.name === type);
  return firstItem ? firstItem.permission : FeatureAccess.NONE;
};
